module.exports = __webpack_public_path__ + "static/images/cover_C4.37c8f60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_C4.png
// module id = D4CP
// module chunks = 8